<!-- <public-header-component></public-header-component> -->
<section class="login-section">
    <div class="login-section-inner">
        <div class="login-left">
            <h2>Upload CSV File </h2>
            <!-- <h2>Hello!</h2> -->

        </div>
        <div class="login-right">
            <div>
                <div class="">
                    <img src="../../../../assets/images/innerLogo.png" class="login-logo">
                </div>
                <div class="alert alert-success" *ngIf="isUploadCompleted">
                    {{isUploadCompleted}}
                    <strong>Info !</strong> Data uploaded successfully, Please check recently downloaded file.
                </div>
                <ng-container *ngIf="csvUploadStsatusResponse?.message==='NoJob' || csvUploadStsatusResponse?.message==='Completed'">
                    
                    <div class=" uploadfile">
                        <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="onFileDropped($event)"
                            (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)">
                            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                                <i class="fa fa-upload"></i><br />
                                <button type="button" (click)="openFileSelector()">Drag and Drop or Select File</button>
                            </ng-template>
                        </ngx-file-drop>

                    </div>                    
                    <div class="file-name">{{fileName}}</div>
                    <div class="btn-upload">
                        <button (click)="importcsv()" class="btn  btn-sign-in my-2 my-sm-0 btn-signIn" type="submit">
                            <i class="fa fa-upload"></i> Upload
                        </button>
                    </div>
                </ng-container>
                <ng-container
                    *ngIf="csvUploadStsatusResponse?.message==='Running'">
                    <div class="alert alert-info">
                        <strong>Info!</strong>File upload is in progress.
                    </div>
                    <div class="btn-upload">
                        <button (click)="cancelUpload()" class="btn  btn-sign-in my-2 my-sm-0 btn-signIn" type="submit">
                            <i class="fa fa-upload"></i> Cancel Upload
                        </button>
                    </div>
                </ng-container>
                <ng-container *ngIf="csvUploadStsatusResponse?.message==='Failed'">
                <div class="alert alert-info">
                    <strong>Info!</strong>Something went wrong.Please retry the 
                    <b><a class="retry" (click)="retry()">import </a> </b>
                </div>
               
            </ng-container>
            </div>
        </div>
    </div>
</section>